import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/Sidebar.css';
import { DEFAULT_PERMISSIONS } from '../auth/usePermissions';

export default function Sidebar({
  onToggleProjects,
  onTogglePlanner,
  activeSidebar,
  permissions = DEFAULT_PERMISSIONS,
}) {
  return (
    <div className="sidebar-nav-content">
      <Link to="/dashboard" className="logo">
        <img src="/logo.png" alt="InteriorFolio Logo" />
      </Link>

      <nav>
        {permissions.dashboard !== false && (
          <Link to="/dashboard" className="nav-item">
            Dashboard
          </Link>
        )}

        {permissions.projects !== false && (
          <button
            className={`nav-expand ${activeSidebar === 'projects' ? 'open' : ''}`}
            onClick={onToggleProjects}
          >
            <span>Projects</span>
            <span className="chev">›</span>
          </button>
        )}

        {permissions.library !== false && (
          <Link to="/products" className="nav-item">
            Products & Services
          </Link>
        )}

        {permissions.planner !== false && (
          <Link to="/vendors" className="nav-item">
            Vendors
          </Link>
        )}

        {permissions.timeBilling !== false && (
          <Link to="/timebilling" className="nav-item">
            Time Billing
          </Link>
        )}

        {permissions.planner !== false && (
          <button
            className={`nav-expand ${activeSidebar === 'planner' ? 'open' : ''}`}
            onClick={onTogglePlanner}
          >
            <span>Planner</span>
            <span className="chev">›</span>
          </button>
        )}

        {permissions.reports !== false && (
          <Link to="/reports" className="nav-item">
            Reports
          </Link>
        )}
      </nav>

      <div className="sidebar-footer">
        <Link to="/support" className="nav-footer-link">
          Support
        </Link>
        {permissions.settings !== false && (
          <Link to="/settings" className="nav-footer-link">
            Settings
          </Link>
        )}

        <button
          className="nav-footer-link"
          onClick={() => {
            localStorage.removeItem('IF_AUTH');
            localStorage.removeItem('IF_REFRESH_TOKEN');
            window.location.href = '/login';
          }}
          style={{ textAlign: 'left', background: 'none', border: 'none', padding: 0 }}
        >
          Sign Out
        </button>
      </div>
    </div>
  );
}
